import { IkasPaymentGateway } from ".";
import { IkasPaymentGatewayTranslation } from "./translation";

export function initIkasPaymentGateway(
  paymentGateway: IkasPaymentGateway,
  locale: string | null
) {
  if (paymentGateway.translations && locale) {
    setTranslations(paymentGateway, paymentGateway.translations, locale);
    delete paymentGateway.translations;
  }
}

function setTranslations(
  paymentGateway: IkasPaymentGateway,
  translations: IkasPaymentGatewayTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name) paymentGateway.name = localeTranslations.name;
    if (localeTranslations?.description)
      paymentGateway.description = localeTranslations.description;
  }
}
